import React, { PureComponent } from 'react';
import { List } from 'immutable';

import SupplieRow from './SupplieRow';

class SuppliesRows extends PureComponent {
  render() {
    const {
      data, setData, remove, swap, interId, artisan, readOnly
    } = this.props;
    return data.map((e, pos) => (
      <SupplieRow
        key={`${e.get('suppliesDate')}-${e.get('bl')}`}
        supplie={e}
        elemPos={pos}
        last={data.size - 1 === pos}
        setData={setData}
        remove={remove}
        swap={swap}
        interId={interId}
        artisan={artisan}
        readOnly={readOnly}
      />
    ));
  }
}

SuppliesRows.defaultProps = {
  data: new List()
};

export default SuppliesRows;
